import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Select from "react-select";
// import { loader_image } from "../_components/Imagepath";
import {  Apitoken, Authtoken } from "../Global";
import PropTypes from 'prop-types';
// import $ from "jquery";

import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
//Material UI Imports
import {
  MenuItem,
} from '@mui/material';

const DecayLoading = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [customersList, setCustomersList] = useState([]);  
    const [permission, setPermission] = useState({});
 let season_id = localStorage.getItem("season_id");
  let para ={season_id:season_id};
  // const [backendSuccess, setBackendSuccess] = useState(null);
  // const [backendErrors, setBackendErrors] = useState(null);
  // const [statusOptions, setStatusOptions] = useState([]);

  const [formData, setFormData] = useState({
    start_date:'',
    end_date:'',
    customer:'',
    
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = (e) => {
  console.log(e);
  }
  
  useEffect(() => {
        setPermission(FindModuleById(450)); 
console.log(permission);


    axios
    .post(
      "/decay-customers/listing", {},
      {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      }
    )
    .then((response) => {
      if (response.data.code === 200) {
        let suppliers = response.data.data.customers;
        let supplierslist = suppliers.map((cat, index) => ({
          label: cat.name,
          value: cat.id,
          key: `categories-${index}`,
        }));
        setCustomersList(supplierslist);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
    axios.post("/decay-sales/listing-decay-sale",para,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.sales);

        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });



     
  }, []);
  
  const editItem = (item)=>{
    window.location.href = "/decay-loading-edit/"+item;
  }
 
  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/decay-sales/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/decay-loading";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


const InvoiceNumberCell = ({ row }) => (
  <a href={`/decay-loading-view/${row.original.id}`} className="">
    {row.original.date}
  </a>
);

// ✅ Define PropTypes
InvoiceNumberCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      date: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
  
const quantityCell = ({ row }) => {        
     const total_items = row.original.items || []; // Ensure it's an array
       const totalquantity = total_items
         .reduce((sum, item) => sum + (item.quantity || 0), 0);
     return <span>{totalquantity}</span>;
  };
  
  quantityCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        items: PropTypes.arrayOf(
          PropTypes.shape({
            quantity: PropTypes.string
          })
        )
      }).isRequired
    }).isRequired
  };
  
const quantityOriginalCell = ({ row }) => {        
     const total_items = row.original.items || []; // Ensure it's an array
      const totalquantity = total_items
         .reduce((sum, item) => sum + (item.original_quantity || 0), 0);
     return <span>{totalquantity}</span>;
  };
  
  quantityOriginalCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        items: PropTypes.arrayOf(
          PropTypes.shape({
            original_quantity: PropTypes.string
          })
        )
      }).isRequired
    }).isRequired
  };
const quantityOriginalDifference = ({ row }) => {        
     const total_decay = row.original.items || [];
      const totaloriginal_quantity = total_decay
         .reduce((sum, item) => sum + (item.original_quantity || 0), 0);
      const totalquantity = total_decay
         .reduce((sum, item) => sum + (item.quantity || 0), 0);

     return <span>{(totalquantity - totaloriginal_quantity)}</span>;
  };
  
  quantityOriginalDifference.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        items: PropTypes.arrayOf(
          PropTypes.shape({
            original_quantity: PropTypes.string
          })
        )
      }).isRequired
    }).isRequired
  };
  
  const PriceCell = ({ row }) => {        
      // const total_items = row.original.items || []; // Ensure it's an array
  
      // console.log(total_items);
      // const calibreDisplay = total_items.map(item => item.price).join(' / ');
    
      // return <span>{calibreDisplay}</span>;
       const total_items = Array.isArray(row.original.items) ? row.original.items : [];
  
      // Get all unique prices
      const uniquePrices = [...new Set(total_items.map(item => item.price))];
  
      // If all prices are same → show one, else show all joined by /
      const priceDisplay =
        uniquePrices.length === 1
          ? uniquePrices[0]
          : uniquePrices.join(" / ");
  
      return <span>{priceDisplay || "N/A"}</span>;
    };
    
    PriceCell.propTypes = {
      row: PropTypes.shape({
        original: PropTypes.shape({
          items: PropTypes.arrayOf(
            PropTypes.shape({
              price: PropTypes.string
            })
          )
        }).isRequired
      }).isRequired
    };
  
const columns = [
  {
    header: 'Date',
    accessorFn: (row) => row.date, // No need for template literals
    Cell: InvoiceNumberCell, // ✅ Use separate component
  },
  {
    header: 'Customer',
    accessorFn: (row) => (row.customer ? row.customer.name : ''),
  },
 
  {
    accessorFn: (row) => (row.item ? row.quantity : ''),
    header: 'Net Weight',
  },
    // {
    //   header: 'Net Weight',
    //   Cell: quantityCell
    // },
 
     {
      header: 'Original Net Weight',
      Cell: quantityOriginalCell
    },
 
  // {
  //   accessorFn: (row) => (row.item ? row.total_original_quantity : ''),
  //   header: 'Original Net Weight',
  // },
 
     {
      header: 'Difference',
      Cell: quantityOriginalDifference
    },
 
  // {
  //   accessorFn: (row) => (row.item ? row.difference : ''),
  //   header: 'Difference',
  // },
  // {
  //   //accessorKey: 'price',
  //   accessorFn: (row) => (row.item ? row.price : ''),
  //   header: 'Price',
  // },
    {
      header: 'Price',
      Cell: PriceCell
    },

  {
    accessorKey: 'total_price',
    header: 'Total Amount',
  },
 
  {
    accessorKey: 'driver_plate_number',
    header: 'Driver Plate Number',
  },
  // {
  //   header: 'Payment Method',
  //   accessorFn: (row) => (row.method ? row.method.title : ''),
  // },
  {
    header: 'Created By',
    accessorFn: (row) =>
      row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
  },
  {
    header: 'Updated By',
    accessorFn: (row) =>
      row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
  },
];



  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Decay Loading</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Decay Loading</li>
                </ul>
              </div>
              <div className="col-auto">
            
                  &nbsp;&nbsp;
                   {permission && permission.add == 1 && (
                            <Link to="/decay-loading-add" className="btn btn-primary me-1">
                            <i className="fas fa-plus"></i>
                          </Link>
                        
                          )} 

                 
              </div>
            </div>
          </div>

          <div id="filter_inputs" className="card filter-card">
              <div className="card-body pb-0">
                <form onSubmit={handleSubmit}>
                <div className="row">

                <div className="col-md-2">
                    <div className="form-group">
                      <label>Sart Date:</label>
                      <input type="date" name="start_date" className="form-control"  value={formData.start_date} onChange={(e) => {
                                handleChange(e);
                              }}  />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>End Date:</label>
                      <input type="date" name="end_date" className="form-control"  value={formData.end_date} onChange={(e) => {
                                handleChange(e);
                              }}  />
                    </div>
                  </div>
                   
                  <div className="col-md-3">
                            <div className="form-group status">
                                <label>Select Customer</label>
                                <Select
                                  value={formData.customer}
                                  name="customer"
                                  data={customersList}
                                  className= "w-100"
                                  onChange={(e) => {
                                  handleChange(e);
                                  }}
                                  options={{
                                    placeholder: "Select Customer",
                                  }}
                                />
                              
                              </div>
                          </div>
                
          
                
                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a href="/decay-sales" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>
                 
                    </div>
                  </div>
                </div>
                </form>
                
              </div>
            </div>
            {permission && permission.list == 1 && (
             <div className="row">  
               <section className="comp-section">
                        <div className="row">
                        <div className="col-md-12">
                        <div className="card card-table">
                                      <div className="card-body">
                                          <div className="table-responsive">

                                          <MaterialReactTable columns={columns} data={data} 
                      
                                                        enableColumnOrdering
                                              
                                                        enablePinning
                                                        enableRowActions
                                                      renderRowActionMenuItems={({ row }) => [
                                                          permission?.update == 1 && (
                                                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                              Edit
                                                            </MenuItem>
                                                          ),
                                                        
                                                          permission?.delete == 1 && (
                                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                              Delete
                                                            </MenuItem>
                                                          ),
                                                        ]}
                                                      />
                                          </div>
                                      </div>
                                    </div>
                        </div>
                        </div>
                    </section>
                    
                  </div>
            )}
           
        </div>
      </div>
    </div>
  );
};
export default DecayLoading;
